import React, { useState, useEffect } from "react";
import TalentDashboard from "./dashboard/TalentDashboard";
import OrganizationDashboard from "./dashboard/OrganizationDashboard";

const UserDashboard = () => {
  const [userRole, setUserRole] = useState(null);
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const parsedUser = JSON.parse(user);
      setUserRole(parsedUser.role);
    } else {
      setUserRole(null);
    }
  }, []);

  switch (userRole) {
    case "organization":
      return <OrganizationDashboard />;
    case "talent":
      return <TalentDashboard />;
    default:
      return <TalentDashboard />;
  }
};

export default UserDashboard;
